// src/views/data.js

export const navLinks = [
    { id: 1, label: '#home', path: '/' },
    { id: 2, label: '#products', path: '/products' },
    { id: 3, label: '#contact', path: '/contact-us' },
  ];
  
export const testimonials = [
  {
    alt: 'Image of Rajesh Sharma',
    src: 'https://images.unsplash.com/photo-1607804963237-8c3601a8772a?...',
    name: 'Rajesh Sharma',
    position: 'Managing Director, Bharat Heavy Fabrications',
    review: `RoboMec Automation's robotic welding systems
            transformed our production line. The precision and
            consistency have drastically reduced defects and
            improved our output quality. Their support team was
            exceptional in guiding us through the implementation
            process.`,
  },
  {
    alt: 'Image of Sneha Iyer',
    src: 'https://images.unsplash.com/photo-1633957897986-70e83293f3ff?...',
    name: 'Sneha Iyer',
    position: 'Operations Manager, Shakti Engineering Works',
    review: `We were impressed by the customization RoboMec
            Automation offered for our material handling
            systems. Their solution streamlined our workflow,
            significantly reducing downtime and increasing
            overall efficiency. Truly a game-changer for our
            manufacturing process!`,
  },
  {
    alt: 'Image of Vikram Patil',
    src: 'https://images.unsplash.com/photo-1500264345546-767369bbd93c?...',
    name: 'Vikram Patil',
    position: 'Owner, Maruti Industrial Solutions',
    review: `The thermal cutting system we purchased from RoboMec
            Automation exceeded our expectations. The precision
            and speed of the equipment have enhanced our
            operations and allowed us to take on more complex
            projects. Highly recommended!`,
  },
  {
    alt: 'Image of Priya Joshi',
    src: 'https://images.unsplash.com/photo-1525186402429-b4ff38bedec6?...',
    name: 'Priya Joshi',
    position: 'CEO, Ganesh Fabrication Industries',
    review: `From consultation to deployment, RoboMec Automation
            provided us with world-class service. Their welding
            rotators and positioners have been pivotal in
            improving the quality and efficiency of our heavy
            fabrication projects.`,
  },
  ];

export const roboticAutomationFeatures = [
  {
    title: 'Robotic Welding Systems',
    description: 'State-of-the-art robotic solutions for precise and efficient welding operations.',
    imageSrc: 'https://i.postimg.cc/wBJLrjMh/6axis-welding-robots.jpg',
    imageAlt: 'Robotic Welding Systems Image',
    gallery: [
      { type: 'image', src: 'https://i.postimg.cc/wBJLrjMh/6axis-welding-robots.jpg', alt: 'Robotic Welding Systems - overview' },
    ],
  },
  {
    title: 'Material Handling Systems',
    description: 'Professional installation of industrial machinery for seamless integration.',
    imageSrc: 'https://i.postimg.cc/W3DvxXJq/material-handling-robot.jpg',
    imageAlt: 'Material Handling Systems Image',
  },
  {
    title: 'Fixtures and Tracks',
    description: 'Customizable fixtures and tracks to support and enhance robotic performance.',
    imageSrc: 'https://images.unsplash.com/photo-1730584475593-1747b86de3b5?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&q=80&w=1080',
    imageAlt: 'Fixtures and Tracks Image',
  },
]

export const mechanizedautomationFeatures = [
  {
    title: 'Girth Welder',
    description: 'High-performance girth welders for seamless circumferential welding.',
    imageSrc: 'https://i.postimg.cc/hj1PKgSL/girth-welder-2.jpg',
    imageAlt: 'Girth Welder Image',
    gallery: [
      { type: 'image', src: 'https://i.postimg.cc/hj1PKgSL/girth-welder-2.jpg', alt: 'Girth welder product' },
    ],
  },
  {
    title: 'Valve/Pipe Cladding Machine',
    description: 'Advanced cladding machines for superior valve and pipe surface protection.',
    imageSrc: 'https://i.postimg.cc/FsjthL9q/valve-cladding-1.png',
    imageAlt: 'Valve/Pipe Cladding Machine Image',
  },
  {
    title: 'Positioners and Turn Tables',
    description: 'Versatile positioners and turntables to optimize welding and assembly processes.',
    imageSrc: 'https://i.postimg.cc/V6f8LW7k/positioner-1.jpg',
    imageAlt: 'Positioners and Turn Tables Image',
  },
  {
    title: 'Pipe Cladding System',
    description: 'Comprehensive systems for efficient pipe cladding applications.',
    imageSrc: 'https://i.postimg.cc/Y0Z7qbxF/pipe-cladding-int-1.jpg',
    imageAlt: 'Pipe Cladding System Image',
    gallery: [
      { type: 'image', src: 'https://i.postimg.cc/Zn7RP8Fj/pipe-cladding-ext-1-png.jpg', alt: 'Pipe cladding system product' },
      { type: 'image', src: 'https://i.postimg.cc/Y0Z7qbxF/pipe-cladding-int-1.jpg', alt: 'Pipe cladding system in operation' },
    ],
  },
  {
    title: 'Pipe Welding System',
    description: 'Integrated solutions for precise and reliable pipe welding.',
    imageSrc: 'https://i.postimg.cc/J0fqqmdq/orbital-welder-1.jpg',
    imageAlt: 'Pipe Welding System Image',
  },
  {
    title: 'Welding Rotators',
    description: 'Durable rotators to facilitate the welding of cylindrical workpieces.',
    imageSrc: 'https://i.postimg.cc/0NF9ZwZN/welding-rotator-1.png',
    imageAlt: 'Welding Rotators Image',
    gallery: [
      { type: 'image', src: 'https://i.postimg.cc/0NF9ZwZN/welding-rotator-1.png', alt: 'Welding rotator product' },
      { type: 'image', src: 'https://i.postimg.cc/WbwrK2Bv/welding-rotator-2.png', alt: 'Welding rotator with column and boom' },
    ],
  },
  {
    title: 'Weld Seamers',
    description: 'Precision seamers for high-quality longitudinal welding seams.',
    imageSrc: 'https://i.postimg.cc/yNd4SyqJ/weld-seamer-1.jpg',
    imageAlt: 'Weld Seamers Image',
  },
  {
    title: 'Welding Column and Boom',
    description: 'Flexible column and boom systems to extend your welding reach.',
    imageSrc: 'https://i.postimg.cc/WbwrK2Bv/welding-rotator-2.png',
    imageAlt: 'Welding Column and Boom Image',
  },
]

export const galleryItems = [
  // { type: 'image', src: 'https://images.unsplash.com/photo-1581092786450-7ef25f140997?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTczNjY4NDczMHw&ixlib=rb-4.0.3&q=80&w=1080', alt: 'Industrial machinery 1', size: 'large' },
  // { type: 'image', src: 'https://images.unsplash.com/photo-1710616513346-268a506d446c?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTczNjY4NDczMHw&ixlib=rb-4.0.3&q=80&w=1080', alt: 'Industrial machinery 2', size: 'small' },
  // { type: 'image', src: 'https://images.unsplash.com/photo-1726858143317-3322c53d9688?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTczNjY4NDczMHw&ixlib=rb-4.0.3&q=80&w=1080', alt: 'Industrial machinery 3', size: 'small' },
  // { type: 'image', src: 'https://images.unsplash.com/photo-1585163218247-7a44236dd0f5?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTczNjY4NDczMXw&ixlib=rb-4.0.3&q=80&w=1080', alt: 'Industrial machinery 4', size: 'large' },
  // { type: 'image', src: 'https://images.unsplash.com/photo-1614326014420-1f0c741ca7e1?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTczNjY4NDczMXw&ixlib=rb-4.0.3&q=80&w=1080', alt: 'Industrial machinery 5', size: 'small' },
  // { type: 'image', src: 'https://images.unsplash.com/photo-1732365898307-758e8eb11abb?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTczNjY4NDczMXw&ixlib=rb-4.0.3&q=80&w=1080', alt: 'Industrial machinery 6', size: 'large' },
  // { type: 'image', src: 'https://images.unsplash.com/photo-1695556513222-ab89abc2f834?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTczNjY4NDczMXw&ixlib=rb-4.0.3&q=80&w=1080', alt: 'Industrial machinery 7', size: 'small' },
  { 
    type: 'video', 
    embed_id: 's7nGeAJAW4Q', 
    alt: 'Positioner' 
  },
  {
    type: 'video',
    embed_id: 'AHNFbBnfhxc',
    alt: 'Spiral pipe-welding system'
  },
  {
    type: 'video',
    embed_id: 'UZ-Q3CAAH3Q',
    alt: 'Robotic welding solution'
  },
  {
    type: 'video',
    embed_id: '3MboIM0C-p8',
    alt: 'Robotic Welding System'
  }

]
  
export const guidingPrinciples = [
    { title: 'Customer Centricity', description: 'We focus on serving our customers.' },
    { title: 'Drive for Innovation', description: 'Continuous innovation creates value.' },
    { title: 'Quality Without Compromise', description: 'We make the best even better.' },
  ];
  
// For the "Mega Menu" or "Dropdown" items
export const DROPDOWN_ITEMS = [
    {
      id: 'page1',
      title: 'Home',
      description:
        'Welcome to our industrial machinery manufacturing company. Explore our range of high-quality machinery solutions.',
      imageSrc: 'path-to-page1-img.jpg',
      path: '/',
    },
    {
      id: 'page2',
      title: 'Products',
      description:
        'Discover our wide selection of industrial machinery products designed to meet various manufacturing needs.',
      imageSrc: 'path-to-page2-img.jpg',
      path: '/products',
    },
    {
      id: 'page3',
      title: 'Services',
      description:
        'Learn about our comprehensive services including installation, maintenance, and customization of industrial machinery.',
      imageSrc: 'path-to-page3-img.jpg',
      path: '/services',
    },
    {
      id: 'page4',
      title: 'Contact Us',
      description:
        'Get in touch with us to discuss your machinery requirements or for any inquiries. We are here to assist you.',
      imageSrc: 'path-to-page4-img.jpg',
      path: '/contact-us',
    },
  ];